import React, { useEffect, useState } from 'react';
import TableComponent from '../../component/form/TableComponent';
import { TableButtons } from '../../types/TableComponent.types';
import { faEye, faUserPlus, faArrowRightFromBracket } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useLoading } from '../../context/loadingContext';
import { members } from '../../api/user';
import { useAuth } from '../../context/authContext';
import { useNavigate } from 'react-router-dom';
import { LoadingScreenLocal } from '../other/LoadingScreen';
import { Button } from '../../component/form/Button';
import { isSuccessCode } from '../../helpers/apiResponse';

const ViewUserScreen: React.FC = () => {

    const { association } = useAuth();
    const nav = useNavigate();
    const [user, setUser] = useState<any[]>([]);
    const [page, setPage] = useState(0); // Current page
    const [limit, setLimit] = useState(10); // Items per page
    const [loading, setLoading] = useState<boolean>(true)

    // Definizione delle colonne della tabella
    const columns = [
        { header: 'Nome', accessor: 'name' },
        { header: 'Cognome', accessor: 'surname' },
        { header: 'Email', accessor: 'email' },
    ];

    const handleAdd = () => {
        nav("/user/add");
    };

    // Funzione per gestire la rimozione di un utente
    const handleRemove = (id: number) => {
        console.log(`Rimuovi l'utente con ID: ${id}`);
    };

    const handleView = (id: number) => {
        console.log(`Modifica l'utente con ID: ${id}`);
    };

    const handlePageChange = (newPage: number) => {
        setPage(newPage);
    };

    const handleLimitChange = (newLimit: number) => {
        setLimit(newLimit);
        setPage(0);
    };

    // Pulsanti delle azioni da mostrare per ogni utente
    const buttons: TableButtons[] = [
        {
            button: (<FontAwesomeIcon icon={faArrowRightFromBracket} title="Rimuovi" />),
            bc: "red",
            placeholder: "Leave",
            action: { param: "id", function: handleRemove }
        },
        {
            button: (<FontAwesomeIcon icon={faEye} title="Visualizza" />),
            bc: "green",
            placeholder: "view",
            action: { param: "id", function: handleRemove }
        }
    ];

    useEffect(() => {
        setLoading(true);

        const displayUser = async () => {
            const users = await members(association.id, page * limit, limit);
            if (isSuccessCode(users.error_code)) {
                setUser(users.data);
                setLoading(false);
            } else {
                setLoading(false);
                nav("/500?process_id=" + users.request_id + "&error_code=" + users.error_code);
            }
        };

        displayUser();
    }, [page, limit]);

    if (loading)
        return (<LoadingScreenLocal />)

    return (
        <div className="view-screen-users">
            <Button name={<FontAwesomeIcon icon={faUserPlus} />} action={handleAdd} />
            <TableComponent
                data={user}
                columns={columns}
                buttons={buttons}
                pages={{
                    enabled: true,
                    onPageChange: handlePageChange,
                    onLimitChange: handleLimitChange,
                    page: page,
                    limit: limit,
                }}

            />
        </div>
    );
};

export default ViewUserScreen;
